import React from "react";
import { Avatar, Tooltip } from "antd";
import { getThumbnailUrl } from "../../../utility/utility"
import '../../../styles/component/employee-avatar.scss';


interface Props {
    name?: {
        firstName?: string;
        lastName?: string;
    };
    thumbnailId?: string;
    profileURL?: string;
    size?: number;
}

const EmployeeAvatar: React.FC<Props> = ({ name, thumbnailId, profileURL, size = 30 }) => {

    const getInitials = () => {
        const first = name?.firstName?.trim()?.charAt(0) || "";
        const last = name?.lastName?.trim()?.charAt(0) || "";
        return (first + last).toUpperCase() || "?";
    };

    const getColor = () => {
        const colors = ["#f56a00", "#7265e6", "#ffbf00", "#00a2ae"];
        const charCode = name?.firstName?.charCodeAt(0) || 0;
        return colors[charCode % colors.length];
    };

    const imageUrl = profileURL || getThumbnailUrl(thumbnailId);
    return (
            <Avatar
                className="employee-avatar"
                size={size}
                src={imageUrl || undefined}
                style={!imageUrl ? { backgroundColor: getColor(), fontSize: "16px" } : {}}
            >
                {!imageUrl && getInitials()}
            </Avatar>
    );
};

export default EmployeeAvatar;